export const APP_STORE_URL = 'itms-apps://itunes.apple.com/app/apple-store/id1175068170?mt=8';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.klue.klue';

export const GET_FROM_APP_STORE_MESSAGE = 'GET - On the App Store';
export const GET_FROM_PLAY_STORE_MESSAGE = 'GET - On Google Play Store';
